import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import {selectToken, selectUser } from 'src/app/state/store/auth/auth.selectors';

export const authGuard: CanActivateFn = (
  _route,
  state: RouterStateSnapshot
) => {
  const store = inject(Store);
  const router = inject(Router);
  const currentRouteInvoked = _route.url.join('/');
  const authRoutes = [
    'login',
  //  'reset-password',
    'set-password',
    'forgot-password',
    'verify-account',
    'account-locked',
    'account-locked-temp',
  ];

  console.log(`router url in guard`, _route.url.join('/'));

  return new Promise((resolve, reject) => {
    const token = store.selectSignal(selectToken);
    const user = store.selectSignal(selectUser);

    const isAuthRoute = authRoutes.some((route) =>
      currentRouteInvoked.includes(route)
    );

    // If user trying to access auth routes and token exists, redirect to appropriate landing page
    if (isAuthRoute && token()) {
      // Determine landing page based on user type
      const landingPage = user()?.user_type === 'super_admin' 
        ? '/business-unit' 
        : '/dashboard';
      router.navigate([landingPage]);
      resolve(false);
    }

    // If user trying to access protected routes and token does not exist, redirect to login
    if (!isAuthRoute && !token()) {
      router.navigate(['/login']);
      resolve(false);
    }

    // if token not exists and auth route, allow access
    if (!token() && isAuthRoute) {
      resolve(true);
    }
    // if token exists and not auth route, allow access
    if (token() && !isAuthRoute) {
      resolve(true);
    }
  });
};
